const ptBr = {
    values: {
        'Post Stage Report': 'Relatório Pós-Estágio',
        'Post stage report': 'Relatório pós-estágio',
        'Export PDF': 'Exportar PDF',
        'No data to display yet': 'Nenhum dado para exibir',
        'Select filters below to proceed and generate your Post Stage Report':
            'Selecione os filtros abaixo para prosseguir e gerar seu Relatório Pós-Estágio',
        Crew: 'Equipe',
        Pad: 'Plataforma',
        Stage: 'Estágio'
    }
}

export default ptBr
